import { render, staticRenderFns } from "./BlockchainInfo.vue?vue&type=template&id=2e6ca2a2&scoped=true&"
import script from "./BlockchainInfo.vue?vue&type=script&lang=ts&"
export * from "./BlockchainInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BlockchainInfo.vue?vue&type=style&index=0&id=2e6ca2a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6ca2a2",
  null
  
)

export default component.exports